module.exports = __webpack_public_path__ + "media/images/top/common/img_voice_worry03-c61dc18cc1f232cc74053e394232a5dd.png";